import React, { ReactElement, ReactNode } from 'react'
import { observer } from 'mobx-react'
import styled from 'styled-components'
import User from '../state/User'
import { PermissionRequirement, satisfiesPermission } from '../util/permissions'
import NoPermission from './NoPermission'
import Spinner from './Spinner'

const SpinnerWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: 60px 0;
`

interface RequirePermissionProps {
  permission?: PermissionRequirement
  children: ReactNode
}

const RequirePermission = observer(
  ({ permission, children }: RequirePermissionProps): ReactElement => {
    if (permission !== undefined && !User.permissionsLoaded) {
      return <SpinnerWrapper><Spinner /></SpinnerWrapper>
    }
    if (!satisfiesPermission(permission)) {
      return <NoPermission />
    }
    return <>{children}</>
  }
)

export default RequirePermission
